module.exports = __webpack_public_path__ + "img/sch5-title.a86db281.png";